<template>
    <centered>
        <div class="row">
            <div class="col text-center pt-5">
                <h2>{{ $t('pwa.disabled-title') }}</h2>
                <base-button type="primary" @click.prevent="goHome">{{ $t('common.go-back-home') }}</base-button>
            </div>
        </div>
    </centered>
</template>

<script>
    import Centered from '../layout/parts/Centered'

    export default {

        components: {
            Centered
        },

        methods: {

            goHome() {
                window.location.href = window.baseURL + '/socrates/ui'
            }
        }
    }
</script>
